import { render, staticRenderFns } from "./UpdateExam.vue?vue&type=template&id=6fa4c9dc&scoped=true"
import script from "./UpdateExam.vue?vue&type=script&lang=js"
export * from "./UpdateExam.vue?vue&type=script&lang=js"
import style0 from "./UpdateExam.vue?vue&type=style&index=0&id=6fa4c9dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa4c9dc",
  null
  
)

export default component.exports